import { render, staticRenderFns } from "./TischbestellungStarten.vue?vue&type=template&id=1f635bf8"
import script from "./TischbestellungStarten.vue?vue&type=script&lang=ts"
export * from "./TischbestellungStarten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports